// extracted by mini-css-extract-plugin
module.exports = {"multi-value":"style_multi-value__julfY","multi-value-text":"style_multi-value-text___s4pG","multi-value-remove":"style_multi-value-remove__MfXj6"};